import React, {useContext,useState,useEffect,useRef} from 'react';
import {MyContext} from '../../login/MyContext';
import {Link} from 'react-router-dom';
import {PDFViewer,Image, Document, Page, Text, View, StyleSheet, fontWeight, Font} from '@react-pdf/renderer';

//import { AddBox, ArrowDownward } from "@material-ui/icons";
import MaterialTable from "material-table";
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';
import Login from '../../login/Login';

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import SignatureCanvas from 'react-signature-canvas'


/**** camara  ***/
import Webcam from "react-webcam";
 
const videoConstraints = {
  width: 540,
  facingMode: "environment",
};

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#FFFFFF',
      
     //top:50,
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 2,
      
     marginTop:80,
     top:40,
    // maxHeight:800,
     
    // marginVertical: 70,
    },
  /*  section2: {
       // margin: 10,
        //padding: 10,
        //flexGrow: 2,
        marginTop:10,
       //top:70,
       //top:-50,
       
      // marginVertical: 70,
      },*/
    image: {
      width: "90",
     // minWidth: '600px',
     //left:"150px",
       // height:"53",
       // paddingLeft:"10%",
      marginLeft:'450',
       // paddingLeft:'50px',
      // marginRight:'15',
      // marginHorizontal:'50%',
        //  padding: 10,
    top:'-80',
       //  paddingTop:"50px",
          //backgroundColor: 'white',
         // top:100,
  },


  image2: {
    width: "65",
   // minWidth: '600px',
   //left:"150px",
     // height:"53",
     // paddingLeft:"10%",
    marginLeft:'20',
     // paddingLeft:'50px',
    // marginRight:'15',
    // marginHorizontal:'50%',
      //  padding: 10,
  //marginTop:'-80',
  marginTop:'10'
     //  paddingTop:"50px",
        //backgroundColor: 'white',
       // top:100,
},

image3: {
    width: "65",
   // minWidth: '600px',
   //left:"150px",
     // height:"53",
     // paddingLeft:"10%",
    marginLeft:'335',
     // paddingLeft:'50px',
    // marginRight:'15',
    // marginHorizontal:'50%',
      //  padding: 10,
  //marginTop:'-80',
  marginTop:'-50'
     //  paddingTop:"50px",
        //backgroundColor: 'white',
       // top:100,
},

  title: {
   // margin: 20,
   borderRadius:'10',
    fontSize: 16,
    textAlign:'20',
   // textAlign: 'center',
    backgroundColor: '#003DA6',
    color:"white",
   // textTransform: 'uppercase',
    //fontFamily: 'Oswald',

    top:'-5'
  },


  title2: {
    // margin: 20,
    borderRadius:'10',
     fontSize: 13,
     textAlign:'20',
     textAlign: 'center',
     backgroundColor: 'gray',
     color:"white",
    // textTransform: 'uppercase',
     //fontFamily: 'Oswald',
 
     marginTop:'14'
   },



   table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  }, 

  table2: { 
    marginTop:'10',
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth:0, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  }, 
  tableRow: { 
    margin: "auto", 
    flexDirection: "row" 
  }, 
  tableCol: { 
    width: "50%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableCol2: { 
    width: "50%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
   // margin: "auto", 
    textAlign:"left",
    right:-5,
    marginTop: 18, 
    fontSize: 12,
    top:-7 
  },
  tableCell2: { 
    // margin: "auto", 
     textAlign:"left",
     right:-5,
     marginTop: 5, 
     fontSize: 12,
     top:-7 
   }


  
  
  });
  

 


/*import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css'*/


//import Row from "./Row";

const multiregistros = {
  documento: "",
  name: "",
  cargo: "",
  clave: "",
  id_empresa_usuario: "",
  nombre_empresa: "",
  documento_empresa: ""
};



function Teletrabajo_suplementario () {

    const[t4,  setE7] = useState('');

    const handlecountrye7=e=>{
    
        setE7(e.target.value);
        const {name, value}=e.target;
       
        setFrameworkSeleccionado((prevState)=>({
          ...prevState,
          [name]: value
        }))
       // console.log(frameworkSeleccionado);
       }


  //Nombre trabajador
const [t4t, setUniversidad]= useState([]);


useEffect( ()=>{

    const interval = setInterval(() => {
 const getcountry2= async ()=>{
  // const req= await fetch("https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php");
  const req= await fetch (`https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php?id_empresa_usuario=${global.idprincipal}`)
   const getres2= await req.json();
   //console.log(getres2);
   //console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");
   setUniversidad(await getres2);

 }
 getcountry2();

}, 2000);

return () => setInterval(interval);

 console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");

},[]);




  //Nombre trabajador

  
  const[t5,  setE75] = useState('');

  const handlecountrye75=e=>{
  
      setE75(e.target.value);
      const {name, value}=e.target;
     
      setFrameworkSeleccionado((prevState)=>({
        ...prevState,
        [name]: value
      }))
     // console.log(frameworkSeleccionado);
     }

  const [t5t, setUniversidad5]= useState([]);


  useEffect( ()=>{
  
      const interval = setInterval(() => {
   const getcountry25= async ()=>{
    // const req= await fetch("https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php");
    const req= await fetch (`https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php?id_empresa_usuario=${global.idprincipal}`)
     const getres25= await req.json();
     //console.log(getres2);
     //console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");
     setUniversidad5(await getres25);
  
   }
   getcountry25();
  
  }, 2000);
  
  return () => setInterval(interval);
  
   console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");
  
  },[]);
  






  //Email trabajador

  
  const[email,  setE75t] = useState('');

  const handlecountrye75t=e=>{
  
      setE75t(e.target.value);
      const {name, value}=e.target;
     
      setFrameworkSeleccionado((prevState)=>({
        ...prevState,
        [name]: value
      }))
     // console.log(frameworkSeleccionado);
     }

  const [emailt, setUniversidad5t]= useState([]);


  useEffect( ()=>{
  
      const interval = setInterval(() => {
   const getcountry25t= async ()=>{
    // const req= await fetch("https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php");
    const req= await fetch (`https://aliraweb.com/apiAlira2/cargar_empleados/nombre_trabajador.php?id_empresa_usuario=${global.idprincipal}`)
     const getres25t= await req.json();
     //console.log(getres2);
     //console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");
     setUniversidad5t(await getres25t);
  
   }
   getcountry25t();
  
  }, 2000);
  
  return () => setInterval(interval);
  
   console.log(global.idprincipal + "aqui fueeeeeeeeeeeeeeee");
  
  },[]);
  




  //camara

  const webcamRef = useRef(null);
  const [url, setUrl] = React.useState(null);

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setUrl(imageSrc);
  }, [webcamRef]);
 
  const onUserMedia = (e) => {
    console.log(e);
  };




  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

  const sigCanvas = useRef({})

  const limpiar_firma = () => sigCanvas.current.clear()
  const [imageURL,setImageURL] = useState(null)
  const guardar_firma = () => setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"))

  const [loading, setLoading] = useState(false);

    function loadData(){
        setLoading(false);

        setTimeout(()=>{
            setLoading(true);
            //alert("No se pudo crear la indicacion")
        }, 100);
    }


    



 const {toggleNav,registerUser} = useContext(MyContext);
  
  const baseUrlAd="https://aliraweb.com/apiAlira2/empresas_usuarios/empleados.php"
  const [data, setData]=useState([]);
  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id:'',
    documento:'',
    name:'',
    cargo:'',
    clave:'',
    id_empresa_usuario:'',
    nombre_empresa:'',
    documento_empresa:'',
  });

  //multiregistros
 const [rows, setRows] = useState([multiregistros]);
  
    const handleOnChange = (index, name, value) => {
      const copyRows = [...rows];
      copyRows[index] = {
        ...copyRows[index],
        [name]: value
      };
      setRows(copyRows);
    };
  
    const handleOnAdd = () => {
      setRows(rows.concat(multiregistros));
    };
  
    const handleOnRemove = index => {
      const copyRows = [...rows];
      copyRows.splice(index, 1);
      setRows(copyRows);
    };





  
  const [idArticulos, setIdArticulos] = useState(-1);

  const handlerCargarArticulos = function (e){
  const opcion = e.target.value;
  console.log(opcion);
  
  setIdArticulos(opcion);

  }

  
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const peticionGet =async() =>{
    await axios.get(`https://aliraweb.com/apiAlira2/empleados/teletrabajo_suplementarios.php?id_u=${global.idprincipal}`)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }


   const peticionPut = async() =>{
    var f = new FormData();
    f.append("name", frameworkSeleccionado.name);
    f.append("documento", frameworkSeleccionado.documento);
    f.append("cargo", frameworkSeleccionado.cargo);
    f.append("clave", frameworkSeleccionado.clave);
    f.append("METHOD", "PUT");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id===frameworkSeleccionado.id){
         framework.name= frameworkSeleccionado.name;
         framework.documento= frameworkSeleccionado.documento;
         framework.cargo= frameworkSeleccionado.cargo;
        framework.clave = frameworkSeleccionado.clave;

       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }



  const peticionPost = async() =>{
    var f = new FormData();
    f.append("documento", frameworkSeleccionado.documento);
    f.append("name", frameworkSeleccionado.name);
    f.append("cargo", frameworkSeleccionado.cargo);
    f.append("id_empresa_usuario", theUser.id);
    f.append("nombre_empresa", theUser.name);
    f.append("documento_empresa", theUser.documento);
    f.append("clave", frameworkSeleccionado.clave);
    f.append("METHOD", "POST");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }



  const peticionDelete = async() =>{
    var f = new FormData();
    f.append("METHOD", "PUT_suspender");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id===frameworkSeleccionado.id){
       }
     });
     setData(dataNueva);
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })


  }


  const [cargo, setCountry]= useState([]);

  useEffect( ()=>{

    const interval = setInterval(() => {
    const getcountry= async ()=>{
   const req= await fetch(`https://aliraweb.com/apiAlira2/empresas_usuarios/cargar_cargos.php?usuarioE=${global.idprincipal}`)
  // const req= await fetch("https://parqueoenvia.co/apiParqueoenvia/zonas/country.php");
      const getres= await req.json();
      console.log(getres);
      setCountry(await getres);
  
    }
    getcountry();

}, 2000);

return () => setInterval(interval);
  
  
   },[]);

  

  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
    (caso==="Editar")?
    abrirCerrarModalEditar():
    abrirCerrarModalEliminar()


  }

  useEffect(()=>{
    

    const interval = setInterval(() => {
      
       peticionGet();
       
     }, 2000);
 
   return () => setInterval(interval);
 
   },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id",
      
    },
    
    {
      title:"DOCUMENTO",
      field: "t5"
    },

    {
        title:"TRABAJADOR",
        field: "t4"
      },

    {
      title:'ULTIMA INTERACCIÓN',
      field:'fecha_firma_trabajador'
    },
      
      {
        title:'Email',
        field:'email'
      },

      
      {
        title:'ESTADO',
        field:'estado',
       
       // render: rowData => <img src={rowData.url} style={{width: 50, borderRadius: '50%'}}/>   
    },
    
    
  ];


  
    
    if(isAuth && theUser.tipo_usuario =="empresa")
    {
  return (
 
<div id="content" class="app-content">

<ol class="breadcrumb float-xl-end">


</ol>


<div class="row">




{/*<div class="col-xl-3 col-md-6">
<div class="widget widget-stats bg-red">
<div class="stats-icon"><i class="fa fa-clock"></i></div>
<div class="stats-info">
<h4>PUNTOS SUSPENDIDOS</h4>
<p>0</p>
</div>
<div class="stats-link">
<Link  to="/Empresas_suspendidas" >Ver Módulo <i class="fa fa-arrow-alt-circle-right"></i></Link>
</div>
</div>
  </div> */}

</div>



<div class="row">

<div class="col-xl-12">


<div class="panel panel-inverse" data-sortable-id="form-stuff-1" data-init="true">

<div class="panel-heading ui-sortable-handle">
<h4 class="panel-title">{theUser.name} - TELETRABAJO SUPLEMENTARIO </h4>
<div class="panel-heading-btn">
<a href="javascript:;" class="btn btn-xs btn-icon btn-default" data-toggle="panel-expand" title="Expandir"><i class="fa fa-expand"></i></a>

</div>
</div>


<div class="panel-body">



<MaterialTable

     
columns={columnas}
data={data}
title= {<><button className="btn btn-success" onClick={()=>abrirCerrarModalInsertar()}> <i class="fas fa-file-contract fa-2x"></i>  CREAR CONTRATO - TELETRABAJO SUPLEMENTARIO</button></> }
backIconButtonText='Página anterior'
pagination
fixedHeader


actions={[

    {
        icon : 'attachment',
        tooltip: 'TELETRABAJO SUPLEMENTARIO',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
      },
 
     
            /*  {
                  icon: 'block',
                  tooltip: 'suspender',
                  onClick: (event, framework) => seleccionarFramework(framework, "Eliminar")
              },
*/
             
]}
/*options={{
  actionsColumnIndex: -1
}}*/
options={{
    
    actionsColumnIndex: -1,
 actionsCellStyle: {
   // backgroundColor: "#ffccdd",
   // color: "#FF00dd"
  
 },

 headerStyle: { backgroundColor: "#348fe2",  headerStyle: { position: 'sticky'}, boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white", padding: "0.75rem 0.9375rem", fontSize: 10}
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar'
    
   },

 

   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}



/>


<form >
    
</form>
</div>






</div>

</div>




</div>


{/*<Modal isOpen={modalEliminar}>
 <ModalBody>
   ¿Estas seguro que desea inhabilitar al usuario {frameworkSeleccionado && frameworkSeleccionado.name}?
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-danger"
     onClick={()=>peticionDelete()}
     >
       SI
     </button>
     <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         NO
     </button>

   </ModalFooter>
 

</Modal> */}





<Modal isOpen={modalEditar} style={{maxWidth:"800px"}} 

>
 <ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fas fa-hands-helping"></i> <font Size="2">TELETRABAJO SUPLEMENTARIO</font></ModalHeader>
 <ModalBody>
 <div  className="content-wrapper">


<div className="content-header">
<div className="container-fluid">
<div className="row">



<div className="col-md-12">
 <PDFViewer  style={{width: "100%", height: "100vh"}}>

<Document title="TELETRABAJO SUPLEMENTARIO" author="CTO_SUPLEMENTARIO" creator="CONTRATO SUPLEMENTARIO" producer="informe" subject="informe" >
<Page size="A4" style={styles.page}  >



<View style={styles.section}>



{
/* data.map(usuario => (  */
<>
 <View style={{marginTop:'-50'}}>
<Text style={{fontSize:'18', margin: 2} }>  

<Text style={{color:'black',textAlign:'center'}}>
CONTRATO INDIVIDUAL DE TRABAJO ATÉRMINO FIJO INFERIOR A UN AÑO -TELETRABAJO (SUPLEMENTARIO) 

  </Text>
 
             
</Text> 




<Image 
style={styles.image}
src="/assets/img/logo/logo-admin.png"
/>


 

<View  style={{marginTop:'10'}}>




<View style={styles.table}> 
<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Nombre del Empleador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t1}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}>
<Text style={styles.tableCell}>NIT</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t2}</Text> 
</View> 


</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Domicilio del Empleador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t3}</Text> 
</View> 


</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Nombre del Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t4}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Cédula de Ciudadanía</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t5}</Text> 
</View> 


</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Dirección del Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t6}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Teléfono del Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t7}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Lugar y fecha de nacimiento del Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t8}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Nacionalidad</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t9}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Cargo u Oficio que desempeñará el Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t10}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Salario Mensual Básico</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t11}</Text> 
</View> 


</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Forma de Pago</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t12}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Fecha de inicio de Labores</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t13}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Fecha de terminación de Labores</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t14}</Text> 
</View> 


</View>





<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Lugar donde ha sido contratado el Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t15} </Text> 
</View> 



</View> 

<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Lugar donde desempeñará labores el Trabajador</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t16} </Text> 
</View> 



</View> 


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Vencimiento del contrato</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>{frameworkSeleccionado && frameworkSeleccionado.t17} </Text> 
</View> 



</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Jornada laboral</Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}> {frameworkSeleccionado && frameworkSeleccionado.t18}</Text> 
</View> 



</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>Modalidad de Contrato </Text> 
</View> 

<View style={styles.tableCol}> 
<Text style={styles.tableCell}>A termino Fijo - Teletrabajo - Suplementario</Text> 
</View> 



</View>








</View>




<View style={{marginTop:'68', textAlign:'justify'}}>

<Text style={{fontSize:'12'}}>  

<Text style={{}}>
Entre los suscritos a saber: Por una parte, {frameworkSeleccionado && frameworkSeleccionado.data1}, sociedad comercial, con Nit {frameworkSeleccionado && frameworkSeleccionado.data2}, quien para el efecto del presente contrato se denominará simplemente como EL EMPLEADOR y por la otra, {frameworkSeleccionado && frameworkSeleccionado.data3}, quien para efectos del presente contrato se denominará EL TELETRABAJADOR, de las condiciones ya dichas, identificados como aparece al pie de sus firmas, se ha celebrado el presente Contrato Individual de Trabajo, regido por el artículo 47 del Código Sustantivo de Trabajo, subrogado por el artículo 5° del Decreto 2351 de 1965, la Ley 1221 de 2008 y el Decreto 884 de 2012 y además por las siguientes cláusulas: 


</Text>
                     
</Text> 


<Text style={{fontSize:'12',  marginTop:'15'}}>


  <Text style={{}}>
  PRIMERA: El objeto del presente contrato es establecer las condiciones de trabajo denominado legalmente como Teletrabajo, conocido como una forma de organización laboral, que consiste en el desempeño de actividades remuneradas o prestación de servicios a terceros utilizando como soporte las tecnologías de la información y la comunicación - TIC para el contacto entre el trabajador y el empleador, sin requerirse la presencia física del trabajador en un sitio específico de trabajo.


</Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


  <Text style={{}}>
  SEGUNDA: La forma de trabajo pactada entre las partes será de TELETRABAJO SUPLEMENTARIO  que laborara dos o tres días a la semana en su casa y el resto del tiempo lo hacen en una oficina. 

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO. En caso de contratación por primera vez EL TELETRABAJADOR, no podrá exigir posteriormente realizar su trabajo en las instalaciones de EL EMPLEADOR, excepto que medie común acuerdo y en ese caso dejaría de ser TELETRABAJADOR.

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
TERCERA: REMUNERACIÓN. EL EMPLEADOR, pagará a EL TELETRABAJADOR por la prestación de sus servicios, el salario señalado indicado, pagadero en las oportunidades arriba señaladas. Dentro de este pago se encuentra incluida la remuneración de los descansos dominicales y festivos de que tratan los capítulos I y Il del título VIl del Código Sustantivo del Trabajo. Se aclara y se conviene que para el caso de las comisiones o cualquier otra modalidad de salario variable, el 82.5% de dichos ingresos, constituye remuneración ordinaria y el 17.5% restante está designado a remunerar el descanso en los días dominicales y festivos de que tratan los capítulos l y II del título VII del Código Sustantivo de Trabajo. 

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO PRIMERO. Para el reconocimiento y pago del trabajo suplementario, dominical o festivo EL EMPLEADOR o sus representantes deben evaluar la necesidad del mismo y autorizarlo previamente por escrito. En consecuencia, no se reconocerá ningún trabajo suplementario o en días de descanso legalmente obligatorio que no haya sido autorizado previamente, como queda dicho. En todo caso no podrán exceder las doce (12) horas extras semanales. 

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO SEGUNDO. Cuando la actividad cumplida por EL TELETRABAJADOR no implique desplazamiento a las instalaciones de EL EMPLEADOR, no se reconocerá el auxilio de transporte de conformidad con lo establecido en el artículo 10 del Decreto 884 de 2012. Caso contrario, se le reconocerá este auxilio en forma proporcional a los días en que deba desplazarse a las instalaciones. 

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO TERCERO. Las partes expresamente acuerdan que lo que reciba EL TELETRABAJADOR o llegue a recibir en el futuro, adicional a su salario ordinario, ya sean beneficios o auxilios habituales u ocasionales, tales como alimentación, habitación o vestuario, rodamiento, medicina prepagada, bonificaciones ocasionales o cualquier otra que reciba durante la vigencia del mismo, en dinero o en especie, no constituyen salario.
De conformidad con lo anterior y teniendo en cuenta que EL EMPLEADOR es el propietario de los medios tecnológicos que utilizará EL TELETRABAJADOR para cumplir a cabalidad con el servicio contratado, los gastos derivados de su uso y mantenimiento serán sufragados por EL EMPLEADOR, así como algunos gastos en que incurre EL TELETRABAJADOR con ocasión de la utilización de los mismos en su domicilio. En consecuencia, los siguientes pagos no serán constitutivos de salario para ningún efecto y, por tanto, no serán tenidos en cuenta como base para la liquidación de prestaciones sociales a cargo del EMPLEADOR, vacaciones e indemnizaciones de conformidad con el artículo 128 del Código Sustantivo del Trabajo, subrogado por el artículo 15 de la Ley 50 de 1990:

</Text>

</Text>

<Text style={{fontSize:'12', marginTop:'5'}}>•	Energía {frameworkSeleccionado && frameworkSeleccionado.data4} ($ {frameworkSeleccionado && frameworkSeleccionado.data5})  </Text>

<Text style={{fontSize:'12', marginTop:'5'}}>•	Mantenimiento medios tecnológicos {frameworkSeleccionado && frameworkSeleccionado.data6} ($ {frameworkSeleccionado && frameworkSeleccionado.data7})  </Text>

<Text style={{fontSize:'12', marginTop:'5'}}>•	Gastos de teléfono {frameworkSeleccionado && frameworkSeleccionado.data8} ($ {frameworkSeleccionado && frameworkSeleccionado.data9}) </Text>

<Text style={{fontSize:'12', marginTop:'5'}}>•	Otros: {frameworkSeleccionado && frameworkSeleccionado.data10} ($ {frameworkSeleccionado && frameworkSeleccionado.data11}) </Text>





<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
CUARTA: JORNADA LABORAL. EL TELETRABAJADOR; prestará sus servicios en una jornada máxima diaria de ocho (8) horas y cuarenta y ocho horas semanales (48), de lunes a sábado, en el horario comprendido entre las 06:00 a.m. y las 9:00 p.m., consideradas como horas diurnas en el artículo 160 del CST. 

</Text>



</Text>




<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO. En caso de necesidad del trabajo en horas dominicales o festivas, se dará aplicación a lo establecido en los artículos 172 y ss., del Código Sustantivo del Trabajo.

</Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
QUINTA: DURACIÓN La duración del presente contrato es a término fijo inferior a un año por el periodo indicado en la parte superior del presente documento. Para efectos de su terminación se dará un preaviso no inferior a treinta días por parte de la empresa empleadora. No obstante, si antes de la fecha de vencimiento del término estipulado, ninguna de las partes avisare por escrito a la otra su determinación de no prorrogar el contrato, con una antelación no inferior a treinta (30) días, éste se entenderá renovado por un periodo igual al inicialmente pactado. 
</Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
Para todos los efectos, este contrato podrá prorrogarse hasta por tres (3) períodos iguales o inferiores al inicialmente pactado, al cabo de los cuales el término de renovación no puede ser inferior a un (1) año, y así sucesivamente. 
      </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
PARÁGRAFO.PERIODO DE PRUEBA Las partes acuerdan un periodo de prueba equivalente a la quinta parte del término fijo contratado. En caso de prórrogas o nuevo contrato entre las partes, se entenderá, que no hay nuevo periodo de prueba. Durante este periodo tanto EL EMPLEADOR como EL TRABAJADOR podrán terminar el contrato en cualquier momento, en forma unilateral, de conformidad con el artículo 80 del Código Sustantivo del Trabajo.
                 </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
SEXTA: SEGURIDAD SOCIAL: Mientras dure la relación laboral, EL TELETRABAJADOR estará afiliado al sistema de salud y de pensiones a través de la entidad que seleccione EL TELETRABAJADOR, así como al sistema de riesgos laborales y a la caja de compensación familiar a la que esté inscrito EL EMPLEADOR.
                 </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
SÉPTIMA: Son obligaciones especiales de EL EMPLEADOR, entre otras, las siguientes:
                 </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
1.	Difundir información y buenas prácticas relacionadas con las tecnologías de la información y las comunicaciones requeridas para implementar prácticas de teletrabajo.
                 </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
2.	Incorporar en el reglamento interno de trabajo, las condiciones especiales para que opere el teletrabajo en la empresa.
                 </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
3.	Suministrar a EL TELETRABAJADOR equipos de trabajo seguros y medios de protección adecuados para la tarea a realizar.
                  </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
4.	Garantizar que EL TELETRABAJADOR reciban una formación e información adecuada sobre los riesgos derivados de la utilización de los equipos informáticos y su prevención.
                  </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
5.	Incluir a EL TELETRABAJADOR dentro del programa de salud ocupacional y permitirle la participación en las actividades del comité paritario de salud ocupacional.
                  </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
6.	Informar y dar una copia a EL TELETRABAJADOR de la política de la empresa en materia de salud y seguridad en el trabajo. 
                     </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
7.	Pagar la remuneración pactada en las condiciones, periodos y lugares convenidos.	
                     </Text>



</Text>

<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
8.	Guardar absoluto respeto a la dignidad personal del trabajador, sus creencias y sentimientos.
                     </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
9.	Dar al TELETRABAJADOR que los solicite, a la expiración del contrato, una certificación en que conste el tiempo de servicio, índole de la labor y salario devengado, e igualmente, hacerle practicar examen de retiro. Se considera que el trabajador por su culpa elude, dificulta o dilata el examen, cuando transcurridos cinco (5) días a partir de su retiro no se presenta donde el médico respectivo para las prácticas del examen, a pesar de haber recibido la orden correspondiente.
                     </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
10.	Conceder a sus trabajadores los permisos necesarios para el ejercicio del derecho al sufragio y para el desempeño de cargos oficiales transitorios de forzosa aceptación, en caso de grave calamidad doméstica debidamente comprobada, para concurrir en su caso al servicio médico correspondiente, para desempeñar comisiones sindicales inherentes a la organización y para asistir al entierro de sus compañeros. Las condiciones para estos permisos serán las establecidas en el reglamento de trabajo.

                            </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
11.	En caso de permiso por votación, el trabajador tendrá derecho a media jornada de descanso compensatorio remunerado por el tiempo que utilice para cumplir su función como elector. Tal descanso compensatorio se disfrutará en el mes siguiente al día de la votación, de común acuerdo con EL EMPLEADOR (L. 403/97).

                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
12.	Conceder al TELETRABAJADOR en caso de fallecimiento de su cónyuge, compañero o compañera permanente o de un familiar hasta el grado segundo de consanguinidad, primero de afinidad y primero civil, una licencia remunerada por luto de cinco (5) días hábiles. La grave calamidad doméstica no incluye la licencia por luto que trata este numeral. Este hecho deberá demostrarse mediante documento expedido por la autoridad competente, dentro de los treinta (30) días siguientes a su ocurrencia.

                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
13.	Conservar el puesto a los trabajadores que estén disfrutando de los descansos remunerados, a que se refiere el numeral anterior, o de licencia de enfermedad motivada por el embarazo o parto.

                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
14.	Conceder en forma oportuna a la TELETRABAJADORA en estado de embarazo, la licencia remunerada con sagrada en el numeral 1° del artículo 236, de forma tal que empiece a disfrutarla de manera obligatoria una (1) semana antes o dos (2) semanas antes de la fecha probable del parto, según decisión de la madre conforme al certificado médico a que se refiere el numeral 3° del citado artículo 236 (Adicionado. L. 1468/2011, art. 3°).

                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
15.	Entregar cada año a sus trabajadores el certificado de ingresos y retención, en donde se plasme todos una relación detallada de los pagos hechos por los conceptos laborales, el monto de las cotizaciones a la seguridad social y el valor retenido en la fuente. 

                            </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
OCTAVA: Son obligaciones especiales de EL TELETRABAJADOR, entre otras, las siguientes:
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
1.	Participar en las actividades de prevención y promoción organizadas por EL EMPLEADOR, el Comité Paritario de Salud Ocupacional, o el Vigía Ocupacional correspondiente.
                            </Text>



</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
2.	Cumplir con las normas, reglamentos e instrucciones del programa de salud ocupacional de EL EMPLEADOR.
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
3.	Utilizar los elementos de protección personal y participar en los programas y actividades de promoción y prevención.
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
4.	Prestar el servicio en el lugar establecido a efectos que la protección del sistema de riesgos laborales pueda cumplir con las prestaciones asistenciales y económicas a su cargo. 
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
5.	Realizar las pausas necesarias que permitan un descanso adecuado y prevención de riesgos laborales.
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
6.	Conservar y restituir en buen estado, salvo deterioro natural, los instrumentos y útiles que les hayan facilitado para el ejercicio de sus funciones.
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
7.	No comunicar a terceros, salvo autorización expresa las informaciones que sean de naturaleza reservada y cuya divulgación pueda ocasionar perjuicios a EL EMPLEADOR, lo que no obsta para denunciar delitos comunes o violaciones del contrato o de las normas legales de trabajo ante las autoridades competentes. 
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>
8.	Observar las medidas preventivas y, higiene prescritas por el médico de la ARL o por las autoridades facultadas para el efecto. Así como observar y acatar las instrucciones y órdenes preventivas de accidentes o de enfermedades profesionales.
                            </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

9.	Todas las demás que de modo general o especial le sean fijadas por sus superiores jerárquicos.
                                       </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

10.	La trabajadora en estado de embarazo debe empezará disfrutar la licencia remunerada consagrada en el numeral 1° del artículo 236, al menos una semana antes de la fecha probable del parto (Adicionado.L. 1468/2011, art. 4°).
                                       </Text>



</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

11.	Informar inmediatamente cualquier cambio de domicilio o lugar de trabajo.
         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

12.	{frameworkSeleccionado && frameworkSeleccionado.data12}
         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

NOVENA: MEDIOS TECNOLÓGICOS Y DE AMBIENTE REQUERIDOS. Se debe entender por medios tecnológicos, entre otros: computadores principales, estaciones de trabajo, computadores personales, computadores portátiles, PDAS, servidores de archivo, servidores de aplicación, servidores de comunicación, servidores de correo, servidores de fax, servidores de web, software, archivos de datos, redes de comunicación interna como la intranet de EL EMPLEADOR, redes de comunicación externa como el internet o la World Wide Web, así como otras formas de medios electrónicos que EL EMPLEADOR pueda poner a disposición de EL TELETRABAJADOR en el futuro, que se denominarán genéricamente como “Medios Electrónicos". 
         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO PRIMERO. Por ser los medios electrónicos propiedad de EL EMPLEADOR, estarán sujetos a control y monitoreo permanente por parte de este, debiendo responder EL TELETRABAJADOR por los daños que lleguen a causarse, excepto los propios del deterioro por el uso normal de los mismos. 

         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO SEGUNDO. EL EMPLEADOR como propietario de los medios tecnológicos y como quiera que el servicio se presta en el domicilio de EL TELETRABAJADOR, asumirá los gastos señalados expresamente en el parágrafo segunda de la cláusula tercera del presente contrato. 

         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO TERCERO. Cuando EL EMPLEADOR suministre los medios o instrumentos con los cuales se cumplirá el servicio contratado por parte de EL TELETRABAJADOR, se deberán tener en cuenta las siguientes disposiciones:

         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

1.	Se proveen con el fin de asistir a EL TELETRABAJADOR en las tareas asignadas.
         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

2.	No deben utilizarse para actividades ilegales, inapropiadas o improductivas.
         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

3.	Son de propiedad exclusiva de EL EMPLEADOR y por tanto no pueden generar ninguna expectativa de privacidad para crear, enviar, recibir o almacenar información personal.
         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

4.	Las contraseñas deben mantener su carácter confidencial, siendo prohibido la instalación o utilización de software o claves de codificación, excepto que estas sean suministradas directamente por EL EMPLEADOR.
      </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA: Son prohibiciones para EL EMPLEADOR, entre otras, las siguientes: 
             </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

1.	Exigir o aceptar dinero del teletrabajador como gratificación para que se admita en el trabajo o por otro motivo cualquiera que se refiera a las condiciones de este.
             </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

2.	Limitar o presionaren cualquier forma a los teletrabajadores en el ejercicio de su derecho de asociación.
             </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

3.	Imponer a los teletrabajadores obligaciones de carácter religioso o político o dificultarles o impedirles el ejercicio del derecho al sufragio. 
             </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

4.	Despedir sin justa causa comprobada a los teletrabajadores que les hubieren presentado pliego de peticiones desde la fecha de presentación del pliego y durante los términos legales de las etapas establecidas para el arreglo del conflicto.
             </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

5.	Ejecutar o autorizar cualquier acto que vulnere o restrinja los derechos de los teletrabajadores o que ofenda su dignidad.
                 </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

6.	Deducir, retener o compensar suma alguna del salario, sin orden suscrita por el trabajador, para cada caso, o sin mandamiento judicial. Tampoco se puede efectuar la retención o deducción sin mandamiento judicial, aunque exista orden escrita del trabajador, cuandoquiera que se afecte el salario mínimo legal o convencional o la parte del salario declarada inembargable por la ley.

                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

7.	Emplear en las certificaciones de que trata el ordinal 7° del artículo 57 del Código Sustantivo de Trabajo, signos convencionales que tienden a perjudicar a los interesados o adoptar el sistema de "lista negra", cualquiera que sea la modalidad que se utilice para que no se ocupe en otras empresas a los teletrabajadores que retiren o sean despedidos.  
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

UNDÉCIMA: Son prohibiciones para EL TELETRABAJADOR, entre otras, las siguientes:
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

1.	Consumir dentro de las horas de trabajo licor o cualquier tipo de narcótico estupefaciente. 
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

2.	Usar los medios tecnológicos en objetivos distintos del trabajo contratado.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

3.	Desobedecer o violar cualquiera de las disposiciones e indicaciones contenidas en el reglamento de higiene y seguridad industrial o no observar las instrucciones y órdenes preventivas de accidentes o enfermedades profesionales.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

4.	Encubrir fallas, dar testimonio falso, presentar informes incompletos, o declaraciones que deformen u oculten la verdad.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

5.	Emplear los dineros del anticipo de cesantías o préstamos para vivienda en fines distintos a los previstos en la ley.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

6.	No incorporarse al trabajo una vez termine el permiso otorgado para asistir a la EPS o ARL.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

7.	Solicitar préstamos especiales o ayuda económica a los clientes o empleados de EL EMPLEADOR, aprovechándose de su cargo o aceptarles donaciones de cualquier clase sin la previa autorización escrita.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

8.	Autorizar o ejecutar sin ser de su competencia, operaciones que afecten los intereses de EL EMPLEADOR, o negociar bienes y/o mercancías de la misma en provecho propio.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

9.	Indicar las prohibiciones propias de las funciones que realice el teletrabajador
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DUODÉCIMA: CLÁUSULA DE CONFIDENCLALIDAD: Los conocimientos que adquiera EL TELETRABAJADOR, por razón de las labores y el cargo que desempeña, bien a través de las reuniones que hayan asistido, ya sea en forma oral o escrita a través de documentos, registros, contratos, libros de contabilidad, bosquejos, folletos, soportes computacionales y, en general, a través de cualquier procedimiento o forma en virtud de las cuales se haga posible tomar conocimiento de tal información, y que deban permanecer en reserva no serán divulgados, en atención a la reserva industrial contemplada por el artículo 238 del Código Penal. Esta información confidencial es de propiedad exclusiva de EL EMPLEADOR y por tanto se compromete a proteger dicha información.
                       </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA TERCERA: INVENCIONES Y DERECHOS DE AUTOR: Las invenciones o descubrimientos realizados por EL TELETRABAJADOR, contratado para investigar pertenecen a EL EMPLEADOR, de conformidad con el artículo 539 del Código de Comercio, así como el artículo 20 y concordantes de la Ley 23 de 1982 sobre Derechos de Autor. En cualquier otro caso el invento pertenece a EL TELETRABAJADOR, salvo cuando este no haya sido contratado para investigar y realice la invención mediante datos o medios conocidos o utilizados en razón de la labor desempeñada, evento en el cual EL TELETRABAJADOR, tendrá derecho a un compensación que se fijará de acuerdo al monto del salario, la importancia del invento o descubrimiento, el beneficio que reporte a EL EMPLEADOR, u otros factores similares.
                               </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA CUARTA: JUSTAS CAUSAS PARA DAR POR TERMINADO EL CONTRATO DE TRABAJO: Además de las justas causas de terminación del contrato de trabajo previstas en la ley, en los diferentes reglamentos y en el reglamento de higiene y seguridad de EL EMPLEADOR, el mismo podrá terminar por una de las siguientes faltas graves que para tal efecto se califican como justas causas de terminación del contrato de trabajo:
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

1.	Revelar o utilizar indebidamente la información confidencial establecida en la cláusula décima segunda del presente contrato.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

2.	Obtener o tratar de obtener permisos, licencias o incapacidades mediante informaciones falsas o inexactas.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

3.	Toda falta de honradez que EL TELETRABAJADOR cometa o intente cometer contra EL EMPLEADOR, contra los compañeros de trabajo y/o contra los proveedores y/o clientes de ella, así sea en cuantía mínima.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

4.	Incumplir las normas de seguridad establecidas por EL EMPLEADOR, para la ejecución de su labor.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

5.	Incumplir las prescripciones médicas ordenadas por la EPS, ARL o el médico del trabajo.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

6.	No informar oportunamente a EL EMPLEADOR el haber sufrido accidente de trabajo, aun en el grado más leve o de apariencia insignificante, cuando tal silencio impida o retarde el procurarle al trabajador accidentado primeros auxilios, asistencia médica y/o tratamiento adecuado.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

7.	Ingerir bebidas alcohólicas, narcóticos o drogas enervantes durante las horas de trabajo, aun sea en cantidad mínima.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

8.	Participar, ejercitar, propiciar o intervenir en espionaje o sabotaje contra EL EMPLEADOR.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

9.	El que EL TELETRABAJADOR, cobre maliciosamente salarios, prestaciones o gastos a que no tenga derecho.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

10.	Utilizar los medios tecnológicos suministrados por EL EMPLEADOR para actividades ilegales, inapropiadas o improductivas.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

11.	Compartir las contraseñas aún con los mismos miembros de la familia de EL TELETRABAJADOR.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

12.	Instalar o utilizar software o claves de codificación, sin autorización expresa por escrito de EL EMPLEADOR.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

13.	{frameworkSeleccionado && frameworkSeleccionado.data13}
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA QUINTA: AUTORIZACIÓN DE DESCUENTO- Cuando por causa emanada directa o indirectamente de la relación contractual existan obligaciones económicas a cargo del TELETRABAJADOR y a favor del EMPLEADOR, como por ejemplo, préstamos o anticipos para gastos pendientes de justificar conforme a las políticas del EMPLEADOR, el valor de reparaciones por daños a elementos de trabajo tales como computadores, aplicaciones de sistemas, equipos de oficina, elementos, herramientas utensilios y demás bienes que EL TELETRABAJADOR  haya recibido para el desempeño de su cargo y que lleguen a faltar al hacer entrega de su cargo, EL TELETRABAJADOR autoriza desde ya el descuento de dichos valores de lo que le corresponda por salarios, liquidación de prestaciones sociales, indemnizaciones o cualquier otro concepto.
                                         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

La presente autorización cumple las condiciones de orden escrita y previa aplicable para cada caso, exigida por el artículo 149 del Código Sustantivo del Trabajo.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO.-. EL TELETRABAJADOR AUTORIZA expresamente a EL EMPLEADOR, para que le descuente de su salario mensual y de su liquidación final de acreencias laborales y de cualquier otra suma que por cualquier concepto le adeuden, las sumas de dinero que se deban pagar por concepto de:
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

1.	Las pérdidas o daños causados a los bienes recibidos por inventarios, elementos de trabajo e instrumentos entregados para la protección de EL TELETRABAJADOR, ya sea por sí o porque se los facilitó a alguien estando bajo su responsabilidad.

                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

2.	Sanciones de autoridades estatales que estén directamente ligadas al desarrollo de sus funciones y que estas se desprendan de la ejecución de las labores del trabajador.

                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

3.	Cuando por causa emanada directa o indirectamente de la relación contractual existan obligaciones de tipo económico a cargo del TELETRABAJADOR y a favor del EMPLEADOR. 

                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA SEXTA: NORMATIVIDAD APLICABLE- Este contrato ha sido redactado estrictamente de acuerdo con la Ley y a la Jurisprudencia y será interpretado de buena fe, y en consonancia con el Código Sustantivo del Trabajo cuyo objeto definido en su Artículo 1o. es lograr la justicia en las relaciones entre empleadores y trabajadores dentro de un espíritu de coordinación económica y equilibrio social.

                                         </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO: El presente contrato de trabajo queda sujeto a las disposiciones legales que regulan las relaciones entre los empleadores y sus empleados y a aquellas que en el futuro lleguen a regirlas, de forma que las disposiciones de cualquier ley, decreto o reglamento que consagre una modificación o cambio en la situación jurídica inherente al presente contrato de trabajo se entenderán automáticamente incorporadas en éste y sustituirán sus estipulaciones y a ellas quedarán sometidas las partes.
                                         </Text>
</Text>






<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA SÉPTIMA: REGLAMENTO INTERNO DE TRABAJO- EL TELETRABAJADOR acepta libremente que debe ajustar su conducta de acuerdo con lo contemplado en el Reglamento Interno de Trabajo del EMPLEADOR, que se encuentra aprobado, que declara bajo la gravedad del juramento que conoce ampliamente y que hace parte de este Contrato, en especial, con el horario, comportamiento y desempeño laboral.
                                         </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA OCTAVA: ACUSE DE RECIBO DEL TEXTO DEL CONTRATO- EL TELETRABAJADOR mediante la suscripción del presente contrato hace constar expresamente y por escrito que recibió de manos de EL EMPLEADOR la copia correspondiente al mismo acuerdo, dando cumplimiento legal y oportuno a lo dispuesto por la Ley Laboral Art. 39 C.S.T.
                                        </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

DÉCIMA NOVENA: LIQUIDACIÓN DEFINITIVA - En consideración a que toda liquidación y pago de salarios y prestaciones exige varios días para obtener los datos y paz y salvos, hacer la liquidación, aprobar y girar cheques; las partes convienen fijar un plazo de 10 días hábiles contados a partir de la fecha de terminación del contrato para que EL EMPLEADOR, pague la liquidación a EL TELETRABAJADOR ordene se reconozca a favor de éste, sin que por ello incurra en mora o sanción alguna. 
                                        </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA: PRESTACIONES SOCIALES- EL TELETRABAJADOR y EL EMPLEADOR, pactan, establecen, y convienen que la duración de este contrato y el pago a las prestaciones sociales a que tiene derecho, se harán según lo establecido en el CÓDIGO SUSTANTIVO DEL TRABAJO, es decir, de manera proporcional al tiempo laborado.
                                        </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA PRIMERA: CURSOS DE CAPACITACIÓN: Las partes de común acuerdo PACTAN, ESTABLECEN Y REGLAMENTAN, que EL TELETRABAJADOR se compromete a asistir puntualmente a cada una de las capacitaciones programadas por EL EMPLEADOR. Igualmente reglamentan, pactan y establecen que EL EMPLEADOR no reconocerá suma extra por el tiempo utilizado para estas capacitaciones. 
                                        </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

PARÁGRAFO ÚNICO: En caso de que EL TELETRABAJADOR se desvincule de la empresa antes de seis meses, EL EMPLEADOR podrá descontar el costo de dicha capacitación. EL TELETRABAJADOR autoriza, mediante la suscripción de este contrato, que EL EMPLEADOR puede descontar dicho valor de su liquidación definitiva de prestaciones sociales.
                                        </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'10'}}>


<Text style={{}}>

VIGÉSIMA SEGUNDA: VISIÓN, MISIÓN Y VALORES CORPORATIVOS DE EL EMPLEADOR: EL EMPLEADOR y EL TELETRABAJADOR pactan, celebran y establecen, que hace parte integral de este contrato LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS de EL EMPLEADOR. Por medio de la suscripción de este contrato EL TELETRABAJADOR manifiesta haber recibido de manos de EL EMPLEADOR el documento contentivo de LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS de EL EMPLEADOR. En consecuencia, EL TELETRABAJADOR se compromete a respetar, valorar, propender, socializar y asumir como propios LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS. 
                                        </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA TERCERA: PROTECCIÓN DE DATOS. EL TELETRABAJADOR por la presente declara que acuerda y autoriza el procesamiento de datos personales por la Empresa (que la empresa podrá obtener por escrito, electrónicamente o de cualquier otro modo)incluyendo, pero sin limitarse a, información general del Empleado (nombre, dirección particular, título académico), afiliaciones al sistema de seguridad social y caja de compensación familiar, situación laboral, permisos de trabajo, información salarial, beneficios laborales y en general información requerida por nómina y recursos humanos sobre el Empleado, información que puede ser considerada “ sensible”, (los “Datos Personales”). Los Datos Personales se procesaran para fines relacionados con : la administración de contrataciones, administración del personal activo, administrar nóminas y otros pagos (por ejemplo, gastos por desplazamiento), afiliaciones al seguro de vida colectivo, manejo de embargos judiciales a través de nómina, administrar salarios y beneficios, dirigir y sancionar a los empleados, llevar a cabo  evaluaciones de los empleados, coordinar el desarrollo profesional de los empleados, permitir el acceso de los empleados a los recursos informáticos de la Empresa y prestarles asistencia en su utilización, planificar actividades empresariales y en general cumplir con las obligaciones legales. El Empleado conoce y acepta expresamente que la Empresa puede en cualquier momento los Datos Personales a disposición de otras compañías del grupo en Colombia o en otros países, para los fines especificados anteriormente. El Empleado asimismo declara conocer y aceptar que la empresa puede requerir poner los Datos Personales o parte de ellos a disposición de las autoridades competentes (incluyendo autoridades fiscales), futuros empleadores y potenciales compradores de la Empresa o de cualquiera de sus activos o negocios, contables, auditores, abogados y otros asesores externos, ya sea que estén localizados en Colombia o en Otros países.
                                        </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA CUARTA. - EL TELETRABAJADOR para todos los efectos legales y en especial para la aplicación del parágrafo 1 del artículo 29 de la ley 789/02, norma que modificó el 65 del C.S.T., se compromete a informar por escrito y de manera inmediata a EL EMPLEADOR cualquier cambio de dirección en su dirección de residencia, teniéndose como suya, la última dirección registrada en la su hoja de vida.
                                              </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA QUINTA. Este contrato ha sido redactado estrictamente de acuerdo con la Ley y jurisprudencia y será interpretado de buena fe y en consonancia con el Código Sustantivo del Trabajo cuyo objeto, definido en su artículo 1º, es lograr la justicia en las relaciones entre Empleadores y Trabajadores dentro de un espíritu de coordinación económica y equilibrio social, así mismo el presente contrato reemplaza en su integridad y deja sin efecto alguno cualquiera otro contrato verbal o escrito celebrado entre las partes con anterioridad. Las modificaciones que se acuerden al presente contrato se anotarán a continuación de su texto.
                                                </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

VIGÉSIMA SEXTA: EFECTOS. Las modificaciones, adiciones, aclaraciones de este contrato se harán constar en su parte final o en comunicación escrita aceptada por las partes. Finalmente, convienen expresamente las partes que dejan sin efecto alguno cualquier otro contrato de trabajo anterior a este, tanto verbal como escrito, puesto que el presente constituye el acuerdo total y único que regula la relación laboral entre EL TELETRABAJADOR y EL EMPLEADOR.
                                                </Text>
</Text>


<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

Para constancia se firma, a los {frameworkSeleccionado && frameworkSeleccionado.data14} días del mes de {frameworkSeleccionado && frameworkSeleccionado.data15} del año {frameworkSeleccionado && frameworkSeleccionado.data16} en la ciudad de {frameworkSeleccionado && frameworkSeleccionado.data17}.      

                                              </Text>
</Text>



<Text style={{fontSize:'12',  marginTop:'15'}}>


<Text style={{}}>

&nbsp; EL EMPLEADOR       

                                              </Text>
 

                                              <Text style={{}}>

&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;EL TRABAJADOR      

                                              </Text>
</Text>



  <Image 
style={styles.image2}
src={"https://www.aliraweb.com/apiAlira2/hoja_de_vida/Imagenes/"+frameworkSeleccionado.firma_trabajador} 
/>   


<Image 
style={styles.image3}
src={"https://www.aliraweb.com/apiAlira2/hoja_de_vida/Imagenes/"+frameworkSeleccionado.firma_trabajador2} 
/> 


<View style={styles.table2}> 
<View style={styles.tableRow}> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}>{frameworkSeleccionado && frameworkSeleccionado.t1}</Text> 
</View> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{frameworkSeleccionado && frameworkSeleccionado.t4}</Text> 
</View> 


</View>

<View style={styles.tableRow}> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}>C.C. No. {frameworkSeleccionado && frameworkSeleccionado.t2}</Text> 
</View> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;C.C. No. {frameworkSeleccionado && frameworkSeleccionado.t5}</Text> 
</View> 


</View>


<View style={styles.tableRow}> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}>Representante Legal</Text> 
</View> 

<View style={styles.tableCol2}> 
<Text style={styles.tableCell2}></Text> 
</View> 


</View>

</View>








</View>






   


  <View >


</View>






</View>





</View>

</> 

//))


}













</View>





</Page>
</Document>


</PDFViewer>




</div>
</div>
</div>
</div>
</div>
 </ModalBody>
 <button className="btn btn-info" onClick={()=>abrirCerrarModalEditar()}><i class="fa-solid fa-circle-xmark"></i> Aceptar</button>
 <ModalFooter>
   
  
 </ModalFooter>
</Modal>


<Modal isOpen={modalInsertar} style={{maxWidth:"800px"}}>
<ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fas fa-hands-helping"></i> <font Size="2">TELETRABAJO SUPLEMENTARIO</font></ModalHeader>
 <ModalBody>
   <div className="form-group">

   <form method="post" action="https://aliraweb.com/apiAlira2/hoja_de_vida/teletrabajo_suplementario.php" target="_parent" name="reset" encType='multipart/form-data'  noValidate>
   <div className="row">

   


   <table class="table table-bordered">
   <tbody>
    <tr>
      
      <td>Nombre del Empleador</td>
      <td> <input type="text" className="form-control" name="t1" onChange={handleChange} 
      value={theUser.name} readOnly /></td>
     
    </tr>
    <tr>
      
      <td>NIT</td>
      <td> <input type="text" className="form-control" name="t2" onChange={handleChange} 
      value={theUser.documento} readOnly
      /></td>
     
    </tr>


    <tr>
      
      <td>Domicilio del Empleador</td>
      <td> <input type="text" className="form-control" name="t3" onChange={handleChange} 
        value={theUser.domicilio} readOnly /></td>
    
    </tr>


    <tr>
      
      <td>Nombre del Trabajador</td>
      <td> 
   
  
               <select name="t4" className="form-select" onChange={(e)=>handlecountrye7(e)}>
                    <option>--Seleccione --</option>
                    {
                      t4t.map( (getcon2)=>(
                       
                    <option key={getcon2.id} value={getcon2.name}> {getcon2.documento} - {getcon2.name} </option>
                 
                      ))
                     
                 }
 
                               
                  </select>
 
                  <br/>
 
                   </td>
     
    </tr>


    <tr>
      
      <td>Cédula de Ciudadanía</td>
      <td>
      
      <select name="t5" className="form-select" onChange={(e)=>handlecountrye75(e)}>
                    <option>--Seleccione --</option>
                    {
                      t5t.map( (getcon2)=>(
                       
                    <option key={getcon2.id} value={getcon2.documento}> {getcon2.documento} </option>
                 
                      ))
                     
                 }
 
                               
                  </select>

      <br/>
      </td>
     
    </tr>


    <tr>
      
      <td>Email trabajador</td>
      <td>
      
      <select name="email" className="form-select" onChange={(e)=>handlecountrye75t(e)}>
                    <option>--Seleccione --</option>
                    {
                      emailt.map( (getcon2)=>(
                       
                    <option key={getcon2.id} value={getcon2.email}> {getcon2.documento} - {getcon2.email} </option>
                 
                      ))
                     
                 }
 
                               
                  </select>

      <br/>
      </td>
     
    </tr>


    <tr>
      
      <td>Dirección del Trabajador</td>
      <td> <input type="text" className="form-control" name="t6" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Teléfono del Trabajador</td>
      <td> <input type="text" className="form-control" name="t7" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Lugar y fecha de nacimiento del Trabajador</td>
      <td> <input type="text" className="form-control" name="t8" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Nacionalidad</td>
      <td> <input type="text" className="form-control" name="t9" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Cargo u Oficio que desempeñará el Trabajador</td>
      <td> <input type="text" className="form-control" name="t10" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Salario Mensual Básico</td>
      <td> <input type="text" className="form-control" name="t11" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Forma de Pago</td>
      <td> <input type="text" className="form-control" name="t12" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Fecha de inicio de Labores</td>
      <td> <input type="text" className="form-control" name="t13" onChange={handleChange} /></td>
     
    </tr>

    <tr>
      
      <td>Fecha de terminación de Labores</td>
      <td> <input type="date" className="form-control" name="t14" onChange={handleChange} /></td>
     
    </tr>


    <tr>
      
      <td>Lugar donde ha sido contratado el Trabajador</td>
      <td> <input type="text" className="form-control" name="t15" onChange={handleChange} /></td>
     
    </tr>

    <tr>
      
      <td>Lugar donde desempeñará labores el Trabajador</td>
      <td> <input type="text" className="form-control" name="t16" onChange={handleChange} /></td>
     
    </tr>

    <tr>
      
      <td>Vencimiento del contrato</td>
      <td> <input type="text" className="form-control" name="t17" onChange={handleChange} /></td>
     
    </tr>

    <tr>
      
      <td>Jornada laboral</td>
      <td> <input type="text" className="form-control" name="t18" onChange={handleChange} /></td>
     
    </tr>
  
  </tbody>
</table>



  <div class="col-12">

<br/>


<label style={{textAlign:'justify'}}>
Entre los suscritos a saber: Por una parte,  <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'2' }} className='' type="text" name="data1" placeholder="XXXXXXXXXXXXX" />, sociedad comercial, con Nit
 <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px'}} className='' type="text" name="data2" placeholder="XXXXXXXXXXXXX" />, quien para el efecto del presente contrato se denominará simplemente como EL EMPLEADOR y por la otra, 
 <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px'}} className='' type="text" name="data3" placeholder="XXXXXXXXXXXXX" />, quien para efectos del presente contrato se denominará EL TELETRABAJADOR, de las condiciones ya dichas, identificados como aparece al pie de sus firmas, se ha celebrado el presente Contrato Individual de Trabajo, regido por el artículo 47 del Código Sustantivo de Trabajo, subrogado por el artículo 5° del Decreto 2351 de 1965, la Ley 1221 de 2008 y el Decreto 884 de 2012 y además por las siguientes cláusulas: 
<br/><br/>PRIMERA: El objeto del presente contrato es establecer las condiciones de trabajo denominado legalmente como Teletrabajo, conocido como una forma de organización laboral, que consiste en el desempeño de actividades remuneradas o prestación de servicios a terceros utilizando como soporte las tecnologías de la información y la comunicación - TIC para el contacto entre el trabajador y el empleador, sin requerirse la presencia física del trabajador en un sitio específico de trabajo.
<br/><br/>SEGUNDA: La forma de trabajo pactada entre las partes será de TELETRABAJO SUPLEMENTARIO  que laborara dos o tres días a la semana en su casa y el resto del tiempo lo hacen en una oficina. 
<br/><br/>PARÁGRAFO. En caso de contratación por primera vez EL TELETRABAJADOR, no podrá exigir posteriormente realizar su trabajo en las instalaciones de EL EMPLEADOR, excepto que medie común acuerdo y en ese caso dejaría de ser TELETRABAJADOR.
<br/><br/>TERCERA: REMUNERACIÓN. EL EMPLEADOR, pagará a EL TELETRABAJADOR por la prestación de sus servicios, el salario señalado indicado, pagadero en las oportunidades arriba señaladas. Dentro de este pago se encuentra incluida la remuneración de los descansos dominicales y festivos de que tratan los capítulos I y Il del título VIl del Código Sustantivo del Trabajo. Se aclara y se conviene que para el caso de las comisiones o cualquier otra modalidad de salario variable, el 82.5% de dichos ingresos, constituye remuneración ordinaria y el 17.5% restante está designado a remunerar el descanso en los días dominicales y festivos de que tratan los capítulos l y II del título VII del Código Sustantivo de Trabajo. 
<br/><br/>PARÁGRAFO PRIMERO. Para el reconocimiento y pago del trabajo suplementario, dominical o festivo EL EMPLEADOR o sus representantes deben evaluar la necesidad del mismo y autorizarlo previamente por escrito. En consecuencia, no se reconocerá ningún trabajo suplementario o en días de descanso legalmente obligatorio que no haya sido autorizado previamente, como queda dicho. En todo caso no podrán exceder las doce (12) horas extras semanales. 
<br/><br/>PARÁGRAFO SEGUNDO. Cuando la actividad cumplida por EL TELETRABAJADOR no implique desplazamiento a las instalaciones de EL EMPLEADOR, no se reconocerá el auxilio de transporte de conformidad con lo establecido en el artículo 10 del Decreto 884 de 2012. Caso contrario, se le reconocerá este auxilio en forma proporcional a los días en que deba desplazarse a las instalaciones. 
<br/><br/>PARÁGRAFO TERCERO. Las partes expresamente acuerdan que lo que reciba EL TELETRABAJADOR o llegue a recibir en el futuro, adicional a su salario ordinario, ya sean beneficios o auxilios habituales u ocasionales, tales como alimentación, habitación o vestuario, rodamiento, medicina prepagada, bonificaciones ocasionales o cualquier otra que reciba durante la vigencia del mismo, en dinero o en especie, no constituyen salario.
De conformidad con lo anterior y teniendo en cuenta que EL EMPLEADOR es el propietario de los medios tecnológicos que utilizará EL TELETRABAJADOR para cumplir a cabalidad con el servicio contratado, los gastos derivados de su uso y mantenimiento serán sufragados por EL EMPLEADOR, así como algunos gastos en que incurre EL TELETRABAJADOR con ocasión de la utilización de los mismos en su domicilio. En consecuencia, los siguientes pagos no serán constitutivos de salario para ningún efecto y, por tanto, no serán tenidos en cuenta como base para la liquidación de prestaciones sociales a cargo del EMPLEADOR, vacaciones e indemnizaciones de conformidad con el artículo 128 del Código Sustantivo del Trabajo, subrogado por el artículo 15 de la Ley 50 de 1990:
<br/><br/>•	Energía <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data4" placeholder="XXXXXXXXXXXXX" />($ <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data5" placeholder="XXXXXXXXXXXXX" />)
<br/><br/>•	Mantenimiento medios tecnológicos <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data6" placeholder="XXXXXXXXXXXXX" /> ($ <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data7" placeholder="XXXXXXXXXXXXX" />)
<br/><br/>•	Gastos de teléfono <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data8" placeholder="XXXXXXXXXXXXX" /> ($ <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data9" placeholder="XXXXXXXXXXXXX" />)
<br/><br/>•	Otros: <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data10" placeholder="XXXXXXXXXXXXX" /> ($ <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1'}} className='' type="text" name="data11" placeholder="XXXXXXXXXXXXX" />)
<br/><br/>CUARTA: JORNADA LABORAL. EL TELETRABAJADOR; prestará sus servicios en una jornada máxima diaria de ocho (8) horas y cuarenta y ocho horas semanales (48), de lunes a sábado, en el horario comprendido entre las 06:00 a.m. y las 9:00 p.m., consideradas como horas diurnas en el artículo 160 del CST. 
<br/><br/>PARÁGRAFO. En caso de necesidad del trabajo en horas dominicales o festivas, se dará aplicación a lo establecido en los artículos 172 y ss., del Código Sustantivo del Trabajo.
<br/><br/>QUINTA: DURACIÓN La duración del presente contrato es a término fijo inferior a un año por el periodo indicado en la parte superior del presente documento. Para efectos de su terminación se dará un preaviso no inferior a treinta días por parte de la empresa empleadora. No obstante, si antes de la fecha de vencimiento del término estipulado, ninguna de las partes avisare por escrito a la otra su determinación de no prorrogar el contrato, con una antelación no inferior a treinta (30) días, éste se entenderá renovado por un periodo igual al inicialmente pactado. 
Para todos los efectos, este contrato podrá prorrogarse hasta por tres (3) períodos iguales o inferiores al inicialmente pactado, al cabo de los cuales el término de renovación no puede ser inferior a un (1) año, y así sucesivamente. 
<br/><br/>PARÁGRAFO.PERIODO DE PRUEBA Las partes acuerdan un periodo de prueba equivalente a la quinta parte del término fijo contratado. En caso de prórrogas o nuevo contrato entre las partes, se entenderá, que no hay nuevo periodo de prueba. Durante este periodo tanto EL EMPLEADOR como EL TRABAJADOR podrán terminar el contrato en cualquier momento, en forma unilateral, de conformidad con el artículo 80 del Código Sustantivo del Trabajo.
<br/><br/>SEXTA: SEGURIDAD SOCIAL: Mientras dure la relación laboral, EL TELETRABAJADOR estará afiliado al sistema de salud y de pensiones a través de la entidad que seleccione EL TELETRABAJADOR, así como al sistema de riesgos laborales y a la caja de compensación familiar a la que esté inscrito EL EMPLEADOR.
<br/><br/>SÉPTIMA: Son obligaciones especiales de EL EMPLEADOR, entre otras, las siguientes:
<br/>1.	Difundir información y buenas prácticas relacionadas con las tecnologías de la información y las comunicaciones requeridas para implementar prácticas de teletrabajo.

<br/>2.	Incorporar en el reglamento interno de trabajo, las condiciones especiales para que opere el teletrabajo en la empresa.

<br/>3.	Suministrar a EL TELETRABAJADOR equipos de trabajo seguros y medios de protección adecuados para la tarea a realizar.

<br/>4.	Garantizar que EL TELETRABAJADOR reciban una formación e información adecuada sobre los riesgos derivados de la utilización de los equipos informáticos y su prevención.

<br/>5.	Incluir a EL TELETRABAJADOR dentro del programa de salud ocupacional y permitirle la participación en las actividades del comité paritario de salud ocupacional.

<br/>6.	Informar y dar una copia a EL TELETRABAJADOR de la política de la empresa en materia de salud y seguridad en el trabajo. 

<br/>7.	Pagar la remuneración pactada en las condiciones, periodos y lugares convenidos.

<br/>8.	Guardar absoluto respeto a la dignidad personal del trabajador, sus creencias y sentimientos.

<br/>9.	Dar al TELETRABAJADOR que los solicite, a la expiración del contrato, una certificación en que conste el tiempo de servicio, índole de la labor y salario devengado, e igualmente, hacerle practicar examen de retiro. Se considera que el trabajador por su culpa elude, dificulta o dilata el examen, cuando transcurridos cinco (5) días a partir de su retiro no se presenta donde el médico respectivo para las prácticas del examen, a pesar de haber recibido la orden correspondiente.

<br/>10.	Conceder a sus trabajadores los permisos necesarios para el ejercicio del derecho al sufragio y para el desempeño de cargos oficiales transitorios de forzosa aceptación, en caso de grave calamidad doméstica debidamente comprobada, para concurrir en su caso al servicio médico correspondiente, para desempeñar comisiones sindicales inherentes a la organización y para asistir al entierro de sus compañeros. Las condiciones para estos permisos serán las establecidas en el reglamento de trabajo.

<br/>11.	En caso de permiso por votación, el trabajador tendrá derecho a media jornada de descanso compensatorio remunerado por el tiempo que utilice para cumplir su función como elector. Tal descanso compensatorio se disfrutará en el mes siguiente al día de la votación, de común acuerdo con EL EMPLEADOR (L. 403/97).

<br/>12.	Conceder al TELETRABAJADOR en caso de fallecimiento de su cónyuge, compañero o compañera permanente o de un familiar hasta el grado segundo de consanguinidad, primero de afinidad y primero civil, una licencia remunerada por luto de cinco (5) días hábiles. La grave calamidad doméstica no incluye la licencia por luto que trata este numeral. Este hecho deberá demostrarse mediante documento expedido por la autoridad competente, dentro de los treinta (30) días siguientes a su ocurrencia.

<br/>13.	Conservar el puesto a los trabajadores que estén disfrutando de los descansos remunerados, a que se refiere el numeral anterior, o de licencia de enfermedad motivada por el embarazo o parto.

<br/>14.	Conceder en forma oportuna a la TELETRABAJADORA en estado de embarazo, la licencia remunerada con sagrada en el numeral 1° del artículo 236, de forma tal que empiece a disfrutarla de manera obligatoria una (1) semana antes o dos (2) semanas antes de la fecha probable del parto, según decisión de la madre conforme al certificado médico a que se refiere el numeral 3° del citado artículo 236 (Adicionado. L. 1468/2011, art. 3°).

<br/>15.	Entregar cada año a sus trabajadores el certificado de ingresos y retención, en donde se plasme todos una relación detallada de los pagos hechos por los conceptos laborales, el monto de las cotizaciones a la seguridad social y el valor retenido en la fuente. 

<br/><br/>OCTAVA: Son obligaciones especiales de EL TELETRABAJADOR, entre otras, las siguientes:
<br/>1.	Participar en las actividades de prevención y promoción organizadas por EL EMPLEADOR, el Comité Paritario de Salud Ocupacional, o el Vigía Ocupacional correspondiente.

<br/>2.	Cumplir con las normas, reglamentos e instrucciones del programa de salud ocupacional de EL EMPLEADOR.

<br/>3.	Utilizar los elementos de protección personal y participar en los programas y actividades de promoción y prevención.

<br/>4.	Prestar el servicio en el lugar establecido a efectos que la protección del sistema de riesgos laborales pueda cumplir con las prestaciones asistenciales y económicas a su cargo. 

<br/>5.	Realizar las pausas necesarias que permitan un descanso adecuado y prevención de riesgos laborales.

<br/>6.	Conservar y restituir en buen estado, salvo deterioro natural, los instrumentos y útiles que les hayan facilitado para el ejercicio de sus funciones.

<br/>7.	No comunicar a terceros, salvo autorización expresa las informaciones que sean de naturaleza reservada y cuya divulgación pueda ocasionar perjuicios a EL EMPLEADOR, lo que no obsta para denunciar delitos comunes o violaciones del contrato o de las normas legales de trabajo ante las autoridades competentes. 

<br/>8.	Observar las medidas preventivas y, higiene prescritas por el médico de la ARL o por las autoridades facultadas para el efecto. Así como observar y acatar las instrucciones y órdenes preventivas de accidentes o de enfermedades profesionales.

<br/>9.	Todas las demás que de modo general o especial le sean fijadas por sus superiores jerárquicos.

<br/>10.	La trabajadora en estado de embarazo debe empezará disfrutar la licencia remunerada consagrada en el numeral 1° del artículo 236, al menos una semana antes de la fecha probable del parto (Adicionado.L. 1468/2011, art. 4°).

<br/>11.	Informar inmediatamente cualquier cambio de domicilio o lugar de trabajo.


<br/><textarea  rows={4} style={{textAlign:"left",backgroundColor:'yellow', borderRadius:'5px'}} className=' form-control' type="text" name="data12" placeholder="12.	Señalar las específicas de la labor a realizar" />

<br/><br/>NOVENA: MEDIOS TECNOLÓGICOS Y DE AMBIENTE REQUERIDOS. Se debe entender por medios tecnológicos, entre otros: computadores principales, estaciones de trabajo, computadores personales, computadores portátiles, PDAS, servidores de archivo, servidores de aplicación, servidores de comunicación, servidores de correo, servidores de fax, servidores de web, software, archivos de datos, redes de comunicación interna como la intranet de EL EMPLEADOR, redes de comunicación externa como el internet o la World Wide Web, así como otras formas de medios electrónicos que EL EMPLEADOR pueda poner a disposición de EL TELETRABAJADOR en el futuro, que se denominarán genéricamente como “Medios Electrónicos". 
<br/><br/>PARÁGRAFO PRIMERO. Por ser los medios electrónicos propiedad de EL EMPLEADOR, estarán sujetos a control y monitoreo permanente por parte de este, debiendo responder EL TELETRABAJADOR por los daños que lleguen a causarse, excepto los propios del deterioro por el uso normal de los mismos. 
<br/><br/>PARÁGRAFO SEGUNDO. EL EMPLEADOR como propietario de los medios tecnológicos y como quiera que el servicio se presta en el domicilio de EL TELETRABAJADOR, asumirá los gastos señalados expresamente en el parágrafo segunda de la cláusula tercera del presente contrato. 
<br/><br/>PARÁGRAFO TERCERO. Cuando EL EMPLEADOR suministre los medios o instrumentos con los cuales se cumplirá el servicio contratado por parte de EL TELETRABAJADOR, se deberán tener en cuenta las siguientes disposiciones:
<br/>1.	Se proveen con el fin de asistir a EL TELETRABAJADOR en las tareas asignadas.
<br/>2.	No deben utilizarse para actividades ilegales, inapropiadas o improductivas.
<br/>3.	Son de propiedad exclusiva de EL EMPLEADOR y por tanto no pueden generar ninguna expectativa de privacidad para crear, enviar, recibir o almacenar información personal.
<br/>4.	Las contraseñas deben mantener su carácter confidencial, siendo prohibido la instalación o utilización de software o claves de codificación, excepto que estas sean suministradas directamente por EL EMPLEADOR.

<br/><br/>DÉCIMA: Son prohibiciones para EL EMPLEADOR, entre otras, las siguientes: 
<br/>1.	Exigir o aceptar dinero del teletrabajador como gratificación para que se admita en el trabajo o por otro motivo cualquiera que se refiera a las condiciones de este.
<br/>2.	Limitar o presionaren cualquier forma a los teletrabajadores en el ejercicio de su derecho de asociación. 
<br/>3.	Imponer a los teletrabajadores obligaciones de carácter religioso o político o dificultarles o impedirles el ejercicio del derecho al sufragio. 
<br/>4.	Despedir sin justa causa comprobada a los teletrabajadores que les hubieren presentado pliego de peticiones desde la fecha de presentación del pliego y durante los términos legales de las etapas establecidas para el arreglo del conflicto.
<br/>5.	Ejecutar o autorizar cualquier acto que vulnere o restrinja los derechos de los teletrabajadores o que ofenda su dignidad.
<br/>6.	Deducir, retener o compensar suma alguna del salario, sin orden suscrita por el trabajador, para cada caso, o sin mandamiento judicial. Tampoco se puede efectuar la retención o deducción sin mandamiento judicial, aunque exista orden escrita del trabajador, cuandoquiera que se afecte el salario mínimo legal o convencional o la parte del salario declarada inembargable por la ley.
<br/>7.	Emplear en las certificaciones de que trata el ordinal 7° del artículo 57 del Código Sustantivo de Trabajo, signos convencionales que tienden a perjudicar a los interesados o adoptar el sistema de "lista negra", cualquiera que sea la modalidad que se utilice para que no se ocupe en otras empresas a los teletrabajadores que retiren o sean despedidos.

<br/><br/>UNDÉCIMA: Son prohibiciones para EL TELETRABAJADOR, entre otras, las siguientes:
<br/>1.	Consumir dentro de las horas de trabajo licor o cualquier tipo de narcótico estupefaciente. 
<br/>2.	Usar los medios tecnológicos en objetivos distintos del trabajo contratado.
<br/>3.	Desobedecer o violar cualquiera de las disposiciones e indicaciones contenidas en el reglamento de higiene y seguridad industrial o no observar las instrucciones y órdenes preventivas de accidentes o enfermedades profesionales.
<br/>4.	Encubrir fallas, dar testimonio falso, presentar informes incompletos, o declaraciones que deformen u oculten la verdad.
<br/>5.	Emplear los dineros del anticipo de cesantías o préstamos para vivienda en fines distintos a los previstos en la ley.
<br/>6.	No incorporarse al trabajo una vez termine el permiso otorgado para asistir a la EPS o ARL.
<br/>7.	Solicitar préstamos especiales o ayuda económica a los clientes o empleados de EL EMPLEADOR, aprovechándose de su cargo o aceptarles donaciones de cualquier clase sin la previa autorización escrita.
<br/>8.	Autorizar o ejecutar sin ser de su competencia, operaciones que afecten los intereses de EL EMPLEADOR, o negociar bienes y/o mercancías de la misma en provecho propio.
<br/>9.	Indicar las prohibiciones propias de las funciones que realice el teletrabajador
<br/><br/>DUODÉCIMA: CLÁUSULA DE CONFIDENCLALIDAD: Los conocimientos que adquiera EL TELETRABAJADOR, por razón de las labores y el cargo que desempeña, bien a través de las reuniones que hayan asistido, ya sea en forma oral o escrita a través de documentos, registros, contratos, libros de contabilidad, bosquejos, folletos, soportes computacionales y, en general, a través de cualquier procedimiento o forma en virtud de las cuales se haga posible tomar conocimiento de tal información, y que deban permanecer en reserva no serán divulgados, en atención a la reserva industrial contemplada por el artículo 238 del Código Penal. Esta información confidencial es de propiedad exclusiva de EL EMPLEADOR y por tanto se compromete a proteger dicha información.
<br/><br/>DÉCIMA TERCERA: INVENCIONES Y DERECHOS DE AUTOR: Las invenciones o descubrimientos realizados por EL TELETRABAJADOR, contratado para investigar pertenecen a EL EMPLEADOR, de conformidad con el artículo 539 del Código de Comercio, así como el artículo 20 y concordantes de la Ley 23 de 1982 sobre Derechos de Autor. En cualquier otro caso el invento pertenece a EL TELETRABAJADOR, salvo cuando este no haya sido contratado para investigar y realice la invención mediante datos o medios conocidos o utilizados en razón de la labor desempeñada, evento en el cual EL TELETRABAJADOR, tendrá derecho a un compensación que se fijará de acuerdo al monto del salario, la importancia del invento o descubrimiento, el beneficio que reporte a EL EMPLEADOR, u otros factores similares.
<br/><br/>DÉCIMA CUARTA: JUSTAS CAUSAS PARA DAR POR TERMINADO EL CONTRATO DE TRABAJO: Además de las justas causas de terminación del contrato de trabajo previstas en la ley, en los diferentes reglamentos y en el reglamento de higiene y seguridad de EL EMPLEADOR, el mismo podrá terminar por una de las siguientes faltas graves que para tal efecto se califican como justas causas de terminación del contrato de trabajo:
<br/>1.	Revelar o utilizar indebidamente la información confidencial establecida en la cláusula décima segunda del presente contrato.
<br/>2.	Obtener o tratar de obtener permisos, licencias o incapacidades mediante informaciones falsas o inexactas.
<br/>3.	Toda falta de honradez que EL TELETRABAJADOR cometa o intente cometer contra EL EMPLEADOR, contra los compañeros de trabajo y/o contra los proveedores y/o clientes de ella, así sea en cuantía mínima.
<br/>4.	Incumplir las normas de seguridad establecidas por EL EMPLEADOR, para la ejecución de su labor.
<br/>5.	Incumplir las prescripciones médicas ordenadas por la EPS, ARL o el médico del trabajo.
<br/>6.	No informar oportunamente a EL EMPLEADOR el haber sufrido accidente de trabajo, aun en el grado más leve o de apariencia insignificante, cuando tal silencio impida o retarde el procurarle al trabajador accidentado primeros auxilios, asistencia médica y/o tratamiento adecuado.
<br/>7.	Ingerir bebidas alcohólicas, narcóticos o drogas enervantes durante las horas de trabajo, aun sea en cantidad mínima.
<br/>8.	Participar, ejercitar, propiciar o intervenir en espionaje o sabotaje contra EL EMPLEADOR.
<br/>9.	El que EL TELETRABAJADOR, cobre maliciosamente salarios, prestaciones o gastos a que no tenga derecho.
<br/>10.	Utilizar los medios tecnológicos suministrados por EL EMPLEADOR para actividades ilegales, inapropiadas o improductivas.
<br/>11.	Compartir las contraseñas aún con los mismos miembros de la familia de EL TELETRABAJADOR.
<br/>12.	Instalar o utilizar software o claves de codificación, sin autorización expresa por escrito de EL EMPLEADOR.
<br/><textarea  rows={4} style={{textAlign:"left", backgroundColor:'yellow', borderRadius:'5px'}} className='form-control' type="text" name="data13" placeholder="13.	Señalar las faltas graves para el teletrabajador de acuerdo con sus funciones" />
<br/><br/>DÉCIMA QUINTA: AUTORIZACIÓN DE DESCUENTO- Cuando por causa emanada directa o indirectamente de la relación contractual existan obligaciones económicas a cargo del TELETRABAJADOR y a favor del EMPLEADOR, como por ejemplo, préstamos o anticipos para gastos pendientes de justificar conforme a las políticas del EMPLEADOR, el valor de reparaciones por daños a elementos de trabajo tales como computadores, aplicaciones de sistemas, equipos de oficina, elementos, herramientas utensilios y demás bienes que EL TELETRABAJADOR  haya recibido para el desempeño de su cargo y que lleguen a faltar al hacer entrega de su cargo, EL TELETRABAJADOR autoriza desde ya el descuento de dichos valores de lo que le corresponda por salarios, liquidación de prestaciones sociales, indemnizaciones o cualquier otro concepto.

<br/><br/>La presente autorización cumple las condiciones de orden escrita y previa aplicable para cada caso, exigida por el artículo 149 del Código Sustantivo del Trabajo.

<br/><br/>PARÁGRAFO.-. EL TELETRABAJADOR AUTORIZA expresamente a EL EMPLEADOR, para que le descuente de su salario mensual y de su liquidación final de acreencias laborales y de cualquier otra suma que por cualquier concepto le adeuden, las sumas de dinero que se deban pagar por concepto de:

<br/>1.	Las pérdidas o daños causados a los bienes recibidos por inventarios, elementos de trabajo e instrumentos entregados para la protección de EL TELETRABAJADOR, ya sea por sí o porque se los facilitó a alguien estando bajo su responsabilidad.
<br/>2.	Sanciones de autoridades estatales que estén directamente ligadas al desarrollo de sus funciones y que estas se desprendan de la ejecución de las labores del trabajador.

<br/>3.	Cuando por causa emanada directa o indirectamente de la relación contractual existan obligaciones de tipo económico a cargo del TELETRABAJADOR y a favor del EMPLEADOR. 

<br/><br/>DÉCIMA SEXTA: NORMATIVIDAD APLICABLE- Este contrato ha sido redactado estrictamente de acuerdo con la Ley y a la Jurisprudencia y será interpretado de buena fe, y en consonancia con el Código Sustantivo del Trabajo cuyo objeto definido en su Artículo 1o. es lograr la justicia en las relaciones entre empleadores y trabajadores dentro de un espíritu de coordinación económica y equilibrio social.

<br/><br/>PARÁGRAFO: El presente contrato de trabajo queda sujeto a las disposiciones legales que regulan las relaciones entre los empleadores y sus empleados y a aquellas que en el futuro lleguen a regirlas, de forma que las disposiciones de cualquier ley, decreto o reglamento que consagre una modificación o cambio en la situación jurídica inherente al presente contrato de trabajo se entenderán automáticamente incorporadas en éste y sustituirán sus estipulaciones y a ellas quedarán sometidas las partes.

<br/><br/>DÉCIMA SÉPTIMA: REGLAMENTO INTERNO DE TRABAJO- EL TELETRABAJADOR acepta libremente que debe ajustar su conducta de acuerdo con lo contemplado en el Reglamento Interno de Trabajo del EMPLEADOR, que se encuentra aprobado, que declara bajo la gravedad del juramento que conoce ampliamente y que hace parte de este Contrato, en especial, con el horario, comportamiento y desempeño laboral.

<br/><br/>DÉCIMA OCTAVA: ACUSE DE RECIBO DEL TEXTO DEL CONTRATO- EL TELETRABAJADOR mediante la suscripción del presente contrato hace constar expresamente y por escrito que recibió de manos de EL EMPLEADOR la copia correspondiente al mismo acuerdo, dando cumplimiento legal y oportuno a lo dispuesto por la Ley Laboral Art. 39 C.S.T.

<br/><br/>DÉCIMA NOVENA: LIQUIDACIÓN DEFINITIVA - En consideración a que toda liquidación y pago de salarios y prestaciones exige varios días para obtener los datos y paz y salvos, hacer la liquidación, aprobar y girar cheques; las partes convienen fijar un plazo de 10 días hábiles contados a partir de la fecha de terminación del contrato para que EL EMPLEADOR, pague la liquidación a EL TELETRABAJADOR ordene se reconozca a favor de éste, sin que por ello incurra en mora o sanción alguna. 

<br/><br/>VIGÉSIMA: PRESTACIONES SOCIALES- EL TELETRABAJADOR y EL EMPLEADOR, pactan, establecen, y convienen que la duración de este contrato y el pago a las prestaciones sociales a que tiene derecho, se harán según lo establecido en el CÓDIGO SUSTANTIVO DEL TRABAJO, es decir, de manera proporcional al tiempo laborado.
 
<br/><br/>VIGÉSIMA PRIMERA: CURSOS DE CAPACITACIÓN: Las partes de común acuerdo PACTAN, ESTABLECEN Y REGLAMENTAN, que EL TELETRABAJADOR se compromete a asistir puntualmente a cada una de las capacitaciones programadas por EL EMPLEADOR. Igualmente reglamentan, pactan y establecen que EL EMPLEADOR no reconocerá suma extra por el tiempo utilizado para estas capacitaciones. 

<br/><br/>PARÁGRAFO ÚNICO: En caso de que EL TELETRABAJADOR se desvincule de la empresa antes de seis meses, EL EMPLEADOR podrá descontar el costo de dicha capacitación. EL TELETRABAJADOR autoriza, mediante la suscripción de este contrato, que EL EMPLEADOR puede descontar dicho valor de su liquidación definitiva de prestaciones sociales.

<br/><br/>VIGÉSIMA SEGUNDA: VISIÓN, MISIÓN Y VALORES CORPORATIVOS DE EL EMPLEADOR: EL EMPLEADOR y EL TELETRABAJADOR pactan, celebran y establecen, que hace parte integral de este contrato LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS de EL EMPLEADOR. Por medio de la suscripción de este contrato EL TELETRABAJADOR manifiesta haber recibido de manos de EL EMPLEADOR el documento contentivo de LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS de EL EMPLEADOR. En consecuencia, EL TELETRABAJADOR se compromete a respetar, valorar, propender, socializar y asumir como propios LA VISIÓN, MISIÓN Y VALORES CORPORATIVOS. 

<br/><br/>VIGÉSIMA TERCERA: PROTECCIÓN DE DATOS. EL TELETRABAJADOR por la presente declara que acuerda y autoriza el procesamiento de datos personales por la Empresa (que la empresa podrá obtener por escrito, electrónicamente o de cualquier otro modo)incluyendo, pero sin limitarse a, información general del Empleado (nombre, dirección particular, título académico), afiliaciones al sistema de seguridad social y caja de compensación familiar, situación laboral, permisos de trabajo, información salarial, beneficios laborales y en general información requerida por nómina y recursos humanos sobre el Empleado, información que puede ser considerada “ sensible”, (los “Datos Personales”). Los Datos Personales se procesaran para fines relacionados con : la administración de contrataciones, administración del personal activo, administrar nóminas y otros pagos (por ejemplo, gastos por desplazamiento), afiliaciones al seguro de vida colectivo, manejo de embargos judiciales a través de nómina, administrar salarios y beneficios, dirigir y sancionar a los empleados, llevar a cabo  evaluaciones de los empleados, coordinar el desarrollo profesional de los empleados, permitir el acceso de los empleados a los recursos informáticos de la Empresa y prestarles asistencia en su utilización, planificar actividades empresariales y en general cumplir con las obligaciones legales. El Empleado conoce y acepta expresamente que la Empresa puede en cualquier momento los Datos Personales a disposición de otras compañías del grupo en Colombia o en otros países, para los fines especificados anteriormente. El Empleado asimismo declara conocer y aceptar que la empresa puede requerir poner los Datos Personales o parte de ellos a disposición de las autoridades competentes (incluyendo autoridades fiscales), futuros empleadores y potenciales compradores de la Empresa o de cualquiera de sus activos o negocios, contables, auditores, abogados y otros asesores externos, ya sea que estén localizados en Colombia o en Otros países.

<br/><br/>VIGÉSIMA CUARTA. - EL TELETRABAJADOR para todos los efectos legales y en especial para la aplicación del parágrafo 1 del artículo 29 de la ley 789/02, norma que modificó el 65 del C.S.T., se compromete a informar por escrito y de manera inmediata a EL EMPLEADOR cualquier cambio de dirección en su dirección de residencia, teniéndose como suya, la última dirección registrada en la su hoja de vida.

<br/><br/>VIGÉSIMA QUINTA. Este contrato ha sido redactado estrictamente de acuerdo con la Ley y jurisprudencia y será interpretado de buena fe y en consonancia con el Código Sustantivo del Trabajo cuyo objeto, definido en su artículo 1º, es lograr la justicia en las relaciones entre Empleadores y Trabajadores dentro de un espíritu de coordinación económica y equilibrio social, así mismo el presente contrato reemplaza en su integridad y deja sin efecto alguno cualquiera otro contrato verbal o escrito celebrado entre las partes con anterioridad. Las modificaciones que se acuerden al presente contrato se anotarán a continuación de su texto.

<br/><br/>VIGÉSIMA SEXTA: EFECTOS. Las modificaciones, adiciones, aclaraciones de este contrato se harán constar en su parte final o en comunicación escrita aceptada por las partes. Finalmente, convienen expresamente las partes que dejan sin efecto alguno cualquier otro contrato de trabajo anterior a este, tanto verbal como escrito, puesto que el presente constituye el acuerdo total y único que regula la relación laboral entre EL TELETRABAJADOR y EL EMPLEADOR.

<br/><br/>Para constancia se firma, a los  <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1' }} className='' type="text" name="data14" placeholder="XXXXX (XX)" /> días del mes de <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'2' }} className='' type="text" name="data15" placeholder="XXXXX" /> del año <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'2' }} className='' type="text" name="data16" placeholder="dos mil veintiuno (202X)" /> en la ciudad de <input style={{textAlign:"center", backgroundColor:'yellow', borderRadius:'5px', lineHeight:'1' }} className='' type="text" name="data17" placeholder="XXXXX" />.

</label>




  
  </div>



   </div>
   <br/>
    <br/>
    <center>

   <label><b>EL EMPELADOR</b></label>
   </center>
   <br/>
   <br/>
   <br/>
   <br/>
              <br/>

              {imageURL 
?
 <img
src={imageURL}
alt= "mi firma"
style={{
  display:"block",
  margin:" 0 auto",
  //border:"1px solid black",
  width: "300px",
 // Height: "100px"
 
}}




/>
: null
}

              <center>
                 <div class="col-5">

<input name="documento_empresa"  className="form-control" type="text" placeholder="Nombres completos" value={theUser.name} autoComplete="off" readOnly
style={{border:"0", textAlign:"center", backgroundColor:"white"}} />
             
            </div>

            </center>
             <center> 
              <div class="col-2" style={{marginTop:"-10px"}}>

<input name="documento"  className="form-control" type="text" placeholder="Documento" value={theUser.documento} autoComplete="off" readOnly
style={{border:"0", textAlign:"center", backgroundColor:"white"}} />
             
            </div>

            </center>

            

 <div style={{paddingTop:"10px"}}>
   <button className="btn btn-primary " onClick={loadData} disabled={loading} ><i class="fa-solid fa-pen-to-square"></i> Crear contrato</button>
   </div>

 
   <div style={{display:"none"}}>
  <input name="id"  className="form-control" type="text" placeholder="I" value={frameworkSeleccionado && frameworkSeleccionado.id} autoComplete="off" readOnly />
   <input type="text" id="txtFoto" name="txtFoto"  value={imageURL}/>
   </div>

   <div style={{display:"none"}}>
  <input name="id_empresa"  className="form-control" type="text" placeholder="Id empresa" value={theUser.id} autoComplete="off" readOnly />
  

  
  </div>

   </form>



 {/*  <Popup style={{zIndex:9999}} modal trigger={<center><button>Firma aqui</button></center>} position="right center"
closeOnDocumentClick={false}
>
 {close => (
  <>
  
  <SignatureCanvas 
  ref={sigCanvas}

  canvasProps={{className: "sigCanvas" }}
/>
<button onClick={close}>Cerrar</button>
<button onClick={limpiar_firma}>Borrar firma</button>
<button onClick={guardar_firma}>Guardar firma</button>
</>
 )}
  </Popup>
*/}


<Modal isOpen={modalEliminar}>
 <ModalBody>
 <SignatureCanvas 
  ref={sigCanvas}

  canvasProps={{className: "sigCanvas" }}
/>

<button onClick={limpiar_firma}>Borrar firma</button>
<button onClick={guardar_firma}>Guardar firma</button>
   </ModalBody>
   <ModalFooter>
         <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         CERRAR
     </button>

   </ModalFooter>
 

</Modal>




 
 
   </div>
 </ModalBody>
 <button className="btn btn-info" onClick={()=>abrirCerrarModalEliminar()}><i class="fa-solid fa-circle-xmark"></i> CREAR FIRMA</button> <br/>
 <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}><i class="fa-solid fa-circle-xmark"></i> Cancelar</button>
 <ModalFooter>
   
  
 </ModalFooter>
</Modal>



</div>
   
  )
}

else if(showLogin){
    return"";
}

}

export default Teletrabajo_suplementario
